export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path stroke=\"#00809D\" stroke-width=\"2\" d=\"M36.26 32l-7.84-8 7.84-8m10.976 16l-7.84-8 7.84-8m-35.279 0l7.84 8-7.84 8M.981 16l7.84 8-7.84 8\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};